class Emitter {
  constructor() {
    this.events = new Map();
  }
  on(event, callback) {
    const callbacks = this.events.get(event) || [];
    callbacks.push(callback);
    if (!this.events.has(event)) {
      this.events.set(event, callbacks);
    }
  }
  off(event, callback) {
    if (this.events.has(event)) {
      const callbacks = this.events.get(event).filter(c => c !== callback);
      this.events.set(event, callbacks);
    }
  }
  emit(event) {
    for (var _len = arguments.length, data = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      data[_key - 1] = arguments[_key];
    }
    if (this.events.has(event)) {
      this.events.get(event).forEach(callback => {
        callback(...data);
        // setTimeout(() => callback(...data), 0);
      });
    }
  }
}

export { Emitter };
//# sourceMappingURL=emitter.js.map
